import { Device } from "@domain/product/monitoring/device";

export class MonitoringProductData {
  public positionId?: string;
  private constructor(
    public quantity: number,
    public name: string,
    public type: string,
    public isAvailable: boolean,
    public matNr: string,
  ) {}
  static create(device: Device, quantity = 1) {
    return new MonitoringProductData(quantity, device.name, device.deviceType, device.isAvailable, device.matNr);
  }

  static createFallback(matNr: string, name: string, quantity = 1) {
    return new MonitoringProductData(quantity, name, "", false, matNr);
  }
}
